module.exports = __webpack_public_path__ + "static/ser-aprender-212cdcb9ca3352ad0f5ac816fe089324.png";